import { useState } from 'react';

interface WeddingImageProps {
  /** Local path to the image (e.g. /images/hero.jpg). */
  src: string;
  /** Remote placeholder shown automatically if `src` fails to load. */
  fallback?: string;
  alt: string;
  className?: string;
  title?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
}

/**
 * Reusable image element for the wedding template.
 * Automatically falls back to a remote placeholder when the local
 * photo has not been uploaded yet, and supports lazy loading.
 */
export default function WeddingImage({
  src,
  fallback,
  alt,
  className = '',
  title,
  loading = 'lazy',
  fetchPriority,
}: WeddingImageProps) {
  const [currentSrc, setCurrentSrc] = useState(src);

  const handleError = () => {
    if (fallback && currentSrc !== fallback) {
      setCurrentSrc(fallback);
    }
  };

  return (
    <img
      src={currentSrc}
      alt={alt}
      title={title}
      loading={loading}
      fetchPriority={fetchPriority}
      className={className}
      onError={handleError}
    />
  );
}